import commonMutations from '@/store/data/common/mutations'
import Vue from 'vue'
import { findIndex, keyBy, sortBy } from 'lodash'
import helpers from './helpers'

const buildFlatObject = (collection) => {
    const base = {}
    for (let i = 0; i < collection.length; i++) {
        base[collection[i].crossId] = collection[i]
    }
    return base
}

const mutations = {
    setCustomTaxonomies(state, { taxoList }) {
        // state.list = helpers.parseData(taxoList)
        // state.customTaxonomies = sortBy(taxoList, taxo => taxo.id)
        Vue.set(state, 'list', helpers.parseData(taxoList))
        Vue.set(
            state,
            'customTaxonomies',
            sortBy(taxoList, taxo => taxo.id)
        )
    },
    setSelectedCustomTaxonomy(state, { id }) {
        // state.selected = id
        Vue.set(state, 'selected', id)
    },

    setCustomTaxonomy(state, { customTaxonomy }) {
        const _customTaxonomiesList = [...state.customTaxonomies, customTaxonomy]
        const _hierarchies = {
            ...state.hierarchies,
            [customTaxonomy.id]: []
        }

        Vue.set(state, 'list', helpers.parseData(_customTaxonomiesList))
        // state.customTaxonomies = _customTaxonomiesList
        // state.hierarchies = _hierarchies
        // state.selected = customTaxonomy.id
        Vue.set(state, 'customTaxonomies', _customTaxonomiesList)
        Vue.set(state, 'hierarchies', _hierarchies)
        Vue.set(state, 'selected', customTaxonomy.id)
    },

    setUpdatedTaxonomy(state, { updatedTaxonomy }) {
        const customTaxonomiesList = state.customTaxonomies
        const _elemIndex = findIndex(customTaxonomiesList, item => item.id == updatedTaxonomy.id)
        customTaxonomiesList.splice(_elemIndex, 1, updatedTaxonomy)

        // state.customTaxonomies = customTaxonomiesList
        // state.list = helpers.parseData(customTaxonomiesList)
        Vue.set(state, 'customTaxonomies', customTaxonomiesList)
        Vue.set(state, 'list', helpers.parseData(customTaxonomiesList))
    },

    setRetrievedItems(state, { id, items, subType, recency }) {
        const _hierarchies = {
            ...state.hierarchies,
            [id]: helpers.parseDataHierarchies(subType, items, id, recency)
        }
        // state.selected = id
        // state.hierarchies = _hierarchies
        Vue.set(state, 'selected', id)
        Vue.set(state, 'hierarchies', _hierarchies)
    },

    setHierarchyIsAlreadyRetrieved(state, { value }) {
        // state.hierarchyIsAlreadyRetrieved = value
        Vue.set(state, 'hierarchyIsAlreadyRetrieved', value)
    },

    setFlattenObjectCollection(state, data) {
        state.collection = data
    },

    setCollection(state, data) {
        // debugger;
        Vue.set(state, 'collection', keyBy(data, 'crossId'))
        // state.collection = data
        // Vue.set(state, 'collection', keyBy(data, 'crossId'))
    },

    setHierarchyTree(state, data) {
        state.tree = data
    },

    updateTaxonomyInCollection(state, { taxoId, segments, frequencyOpts }) {
        // Remove all segment of a taxo in collection
        let data = Object.values(state.collection).filter(i => !i?.parentsIds?.some(id => id == 'CustomTaxonomy_' + taxoId) || !i?.parentIds?.some(id => id == 'CustomTaxonomy_' + taxoId))

        if (!data) {
            // Regenerate collection
            data = helpers.instanciateAll(state.customTaxonomies, segments, { frequencyOpts }, data)
            // Store it
            Vue.set(state, 'collection', keyBy(data, 'crossId'))
        }
    },


    setFrequencyOpts(state, frequencyOpts) {
        Object.values(state.collection).forEach(cs => {
            cs.setFrequencyOpts(frequencyOpts)
        })
    },

    setIsLoading(state, data) {
        state.isLoading = data
    },

    setBuilderIsLoading(state, data) {
        state.builderIsLoading = data
    },

    setTaxonomiesCount(state, count) {
        state.taxonomiesCount = count
    },

    setSegmentsCount(state, count) {
        state.segmentsCount = count
    },

}
export default { ...commonMutations, ...mutations }
